import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import AuditionVideoStore from '@src/pages/audition-video/store';
import Page from '../../components/page';
import cx from 'classnames';
import Link from '@src/components/link';
import SimpleSwiper from '@src/components/swiper/simple-swiper';
import CommonHeader from '@src/business-components/common-header';
import CommonFooterModal from '@src/business-components/common-footer-modal';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const AuditionVideo = () => {
  const store = useStore(() => new AuditionVideoStore());
  const currentVideo = store.images[store.currentIndex];
  return (
    <Page className={styles.root}>
      <CommonHeader store={store.commonHeaderStore} />
      <div className={styles.feature}>
        <div className={styles.featureImg}>
          {/* {store.showFeature && (
            <SimpleSwiper params={store.paramsImg} key={store.images.length}>
              {store.images.map((item, index) => {
                return (
                  <div key={index} className={cx(styles.img, styles.video)}>
                    <img className={cx(styles.img)} key={index} src={item.img} alt={item.title} />
                    <Link
                      className={styles.play}
                      onClick={() => {
                        $$tracker.clickStzxPlayVideo(item.title);
                        store.openVideo(item);
                      }}
                    />
                  </div>
                );
              })}
            </SimpleSwiper>
          )} */}
          <img src={currentVideo?.img} alt={currentVideo?.title} />
          <div className={styles.videoMask} />
          <Link
            className={styles.play}
            onClick={() => {
              $$tracker.clickStzxPlayVideo(currentVideo?.title);
              store.openVideo(currentVideo);
            }}
          />
          {/* {store.images.map((item, index) => {
            return (
              <div key={index} className={cx(styles.img, styles.video)}>
                <Link
                  className={styles.play}
                  onClick={() => {
                    $$tracker.clickStzxPlayVideo(item.title);
                    store.openVideo(item);
                  }}
                />
              </div>
            );
          })} */}
        </div>
        <div className={styles.content}>
          <div className={styles.backContent}>
            <Link className={styles.back} onClick={() => store.goBack()} />
          </div>
          <div className={styles.featureSwiper}>
            {store.showSwiper &&
              store.images.length >= 3 && (
                <SimpleSwiper params={store.params}>
                  {store.images.map((item, index) => (
                    <div className={styles.swiperItem} key={index}>
                      <img src={item.thumbImg} alt={item.title} className={styles.thumbnail} />
                      <img src={item.title_thumbnail} alt="" className={cx(styles.title, styles.titleDefault)} />
                      <img src={item.title_thumbnail_selected} alt="" className={cx(styles.title, styles.titleSelected)} />
                    </div>
                  ))}
                </SimpleSwiper>
              )}
            {store.images.length < 3 && (
              <div className={styles.featureSwiperBox}>
                {store.images.map((item, index) => (
                  <div
                    className={cx(styles.swiperItem, store.currentIndex === index && 'swiper-slide-active')}
                    key={index}
                    onClick={() => store.changeIndex(index)}
                  >
                    <img src={item.thumbImg} alt={item.title} className={styles.thumbnail} />
                    <img src={item.title_thumbnail} alt="" className={cx(styles.title, styles.titleDefault)} />
                    <img src={item.title_thumbnail_selected} alt="" className={cx(styles.title, styles.titleSelected)} />
                  </div>
                ))}
              </div>
            )}

            {store.images.length >= 3 && (
              <div className={styles.swiperAction}>
                <Link className={cx(styles.swiperBtn, styles.prev)} onClick={() => store.changeSwiper('prev')} />
                <Link className={cx(styles.swiperBtn, styles.next)} onClick={() => store.changeSwiper('next')} />
              </div>
            )}
          </div>
        </div>
        <CommonFooterModal />
      </div>
    </Page>
  );
};

export default observer(AuditionVideo);
